import { isAllowedInCountry } from "@/lib/country-gates"
import type { Country } from "@/i18n/config"

/**
 * Can this test-detail question card link to its insights article?
 *
 * The question cards link to article slugs hardcoded in `data/tests.ts` and
 * the `*_QA_ARTICLE_SLUGS` maps in `test-detail-client.tsx`. Two independent
 * things can make such a link dead, and both must be checked:
 *
 *   1. the insights surface itself is absent in this country (`page:insights`
 *      — DE has no insights pages at all), and
 *   2. the specific post is hidden in this market via the CMS
 *      `hideInCountries` field, which `getBlogPosts(locale, country)` already
 *      filters out.
 *
 * Only (1) used to be checked, so NL — where editors hide 29 of 35 posts to
 * keep the reviewed Dutch subset — shipped six links to `/nl/nl/insights/…`
 * URLs that render "Article not found". Passing `visibleArticleSlugs` from the
 * country-filtered CMS fetch makes the link track the CMS field: unhide a post
 * and its link returns, with no code change.
 */
export function canLinkArticle(
  slug: string | undefined,
  country: Country,
  visibleArticleSlugs: readonly string[]
): slug is string {
  return (
    !!slug &&
    isAllowedInCountry("page:insights", country) &&
    visibleArticleSlugs.includes(slug)
  )
}
